/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from 'react';
import { FluidContainer, TablePlayerWellness } from '../../../components';
import { TableWrapper } from '../styles';
import { ARMcontext } from '../../../utils/context/context';
import { Teams } from '../../../utils/api';
import { Loader } from '../../../components';

export default () => {
  const [data, useData] = useState<any>([]);
  const { selectedPlayer } = useContext(ARMcontext);
  const [loadingTable, setLoadingTable] = useState(true);
  const TEAMS = new Teams();
  useEffect(() => {
    fetchPlayerWellness();
  }, [selectedPlayer]);
  async function fetchPlayerWellness() {
    const res = await TEAMS.GetWellnessRecordsFromPlayer(selectedPlayer._id);
  
    useData(res?.data);
    setLoadingTable(false)

  }
  return (
    <>
      <FluidContainer>
        <TableWrapper>
          {loadingTable ?
            <div style={{ width: '100%', display: 'block', alignItems: 'center' }}>
              <Loader height="90px" />
            </div> :
            <TablePlayerWellness dataTableContent={data} />}
        </TableWrapper>
      </FluidContainer>
    </>
  );
};
